
interface Array<T> {
  getProp(id: string, propName: string): string | null
	set(props: T[], constructor?: any): T[]
}

Array.prototype.getProp = function (id: string, propName: string) {
  const found = this.find(i => i.id === id)
  if (found) {
    return found[propName]
  }
  return null
}

Array.prototype.set = function(props, constructor) {
	while (this.length > 0) {
		this.pop();
	}

	if (props) {
		if (props.length) {
			if (constructor) {
				for (const prop of props) {
					this.push(new constructor(prop));
				}
			} else {
				for (const prop of props) {
					this.push(prop);
				}
			}
		}
	}

	return this;
};
